import { useEffect, useState } from 'react'
import { logAnonEvent } from '../utils/logEvent'
import AboutChimp from '../components/home/about/AboutChimp'
import Contact from '../components/home/contact/Contact'
import Features from '../components/home/features/Features'
import Footer from '../components/home/footer/Footer'
import Header from '../components/home/header/Header'
import HeroBanner from '../components/home/hero/HeroBanner'
import Offerings from '../components/home/offerings/Offerings'
import PartnersBanner from '../components/home/partners/PartnersBanner'
import WhyChimp from '../components/home/whyChimp/WhyChimp'
import AOS from 'aos'
import 'aos/dist/aos.css'
import ScrollUp from '../components/home/scrollUp/ScrollUp'
import HowItWorks from '../components/home/howItWorks/HowItWorks'
import TeamSection from '../components/home/team/Team'
import Milestones from '../components/home/milestones/Milestones'
// import PricingSection from '../components/home/pricing/Pricing';
import BotHero from '../components/home/hero/BotHero'  
const VERIFIED_MESSAGES = {
  true:    { text: 'Email verified! You can now log in.', type: 'success' },
  already: { text: 'Your email is already verified. Go ahead and log in.', type: 'success' },
  expired: { text: 'That verification link has expired. Please sign up again.', type: 'error' },
  invalid: { text: 'Invalid verification link.', type: 'error' },
  error:   { text: 'Something went wrong. Please try again.', type: 'error' },
}

const HomePage = ({openReg,setOpenReg,setOpenAuth,openAuth,handleAuth}) => {
  AOS.init()
  const [toast, setToast] = useState(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    // ── Email verification redirect handling ──────────────────────────────
    const verifiedParam = params.get('verified')
    if (verifiedParam && VERIFIED_MESSAGES[verifiedParam]) {
      const { text, type } = VERIFIED_MESSAGES[verifiedParam]
      setToast({ text, type })
      // Auto-open login modal for successful verifications
      if (verifiedParam === 'true' || verifiedParam === 'already') {
        setOpenAuth('login')
        setOpenReg(true)
        document.documentElement.classList.add('disable-scroll')
      }
      // Clean the param from the URL so a refresh doesn't re-trigger it
      window.history.replaceState({}, '', '/')
      // Auto-dismiss after 6 seconds
      setTimeout(() => setToast(null), 6000)
    }

    // ── Anonymous page view tracking ──────────────────────────────────────
    const utm = {}
    if (params.get('utm_source')) utm.utm_source = params.get('utm_source')
    if (params.get('utm_medium')) utm.utm_medium = params.get('utm_medium')
    if (params.get('utm_campaign')) utm.utm_campaign = params.get('utm_campaign')
    logAnonEvent({
      action: 'page_view',
      content: JSON.stringify({ page: '/', referrer: document.referrer || 'direct', ...utm }),
    })
  }, [])

  return (
    <>
      {/* ── Verification toast ── */}
      {toast && (
        <div style={{
          position: 'fixed', top: 24, left: '50%', transform: 'translateX(-50%)',
          zIndex: 9999, display: 'flex', alignItems: 'center', gap: 10,
          background: toast.type === 'success' ? '#432C5B' : '#b91c1c',
          color: '#fff', padding: '14px 24px', borderRadius: 12,
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          fontSize: 14, fontFamily: 'Poppins, sans-serif', fontWeight: 500,
          maxWidth: 420, textAlign: 'center', pointerEvents: 'none',
        }}>
          <span style={{ fontSize: 18 }}>{toast.type === 'success' ? '✓' : '✕'}</span>
          {toast.text}
        </div>
      )}

      <Header openReg={openReg} setOpenReg={setOpenReg} openAuth={openAuth} setOpenAuth={setOpenAuth} handleAuth={handleAuth}/>
      <HeroBanner openReg={openReg} setOpenReg={setOpenReg} openAuth={openAuth} setOpenAuth={setOpenAuth} handleAuth={handleAuth}/>
      <PartnersBanner />
        
      <div className='gradient'>
        <div data-aos="fade" data-aos-delay="200">
          <BotHero setOpenAuth={setOpenAuth} handleAuth={handleAuth} />
        </div>
        <div data-aos="fade" data-aos-delay="250">
        <AboutChimp openReg={openReg} setOpenReg={setOpenReg} openAuth={openAuth} setOpenAuth={setOpenAuth} handleAuth={handleAuth}/>
      </div>
      <div data-aos="fade" data-aos-delay="250">
        <Features openReg={openReg} setOpenReg={setOpenReg} openAuth={openAuth} setOpenAuth={setOpenAuth} handleAuth={handleAuth}/>
      </div>
      </div>
      
      <div data-aos="fade" data-aos-delay="250">
        <HowItWorks openReg={openReg} setOpenReg={setOpenReg} openAuth={openAuth} setOpenAuth={setOpenAuth} handleAuth={handleAuth}/>
      </div>
      <div data-aos="fade" data-aos-delay="250">
        <WhyChimp openReg={openReg} setOpenReg={setOpenReg} openAuth={openAuth} setOpenAuth={setOpenAuth} handleAuth={handleAuth}/>
      </div>
      <div data-aos="fade" data-aos-delay="250">
       <TeamSection />
      </div>
      <div data-aos="fade" data-aos-delay="250">
        <Milestones />
      </div>
      {/* <div data-aos="fade" data-aos-delay="250">
       <PricingSection />
      </div> */}
      <div data-aos="fade" data-aos-delay="250">
        <Contact openReg={openReg} setOpenReg={setOpenReg} openAuth={openAuth} setOpenAuth={setOpenAuth} handleAuth={handleAuth}/>
      </div>
      <Footer openReg={openReg} setOpenReg={setOpenReg} openAuth={openAuth} setOpenAuth={setOpenAuth} handleAuth={handleAuth}/>
      <ScrollUp/>
    </>
  )
}
export default HomePage
